import React, { useEffect, useState } from 'react';
import { Layer, LayerProps, Source } from 'react-map-gl';
import { SheetVersion } from 'records/SheetVersion';
import { getCroppedPDFSourceUrl } from 'utils/map';

type CroppedSheetProps = {
  sheetSource: MapboxSheetSourceConfig;
  sheetLayer: MapboxSheetLayerConfig;
  cropPath: Point[];
  sheetVersion: SheetVersion;
};

export type MapboxSheetSourceConfig = {
  id: string;
  type: string;
  url: string;
  coordinates: number[][];
};

export type MapboxSheetLayerConfig = {
  id: string;
  source: string;
  type: LayerProps['type'];
  paint?: LayerProps['paint'];
};

const CroppedSheet: React.FC<CroppedSheetProps> = ({
  sheetSource,
  sheetLayer,
  cropPath,
  sheetVersion,
}: CroppedSheetProps) => {
  const [pdfSourceUrl, setPDFSourceUrl] = useState<string>('');

  const canvasId = `${sheetSource.id}-canvas`;
  const paint = sheetLayer.paint ?? {};

  const setCropPDFSourceUrl = async () => {
    const cropPDFUrl = await getCroppedPDFSourceUrl(
      sheetVersion,
      cropPath,
      sheetSource.url,
      canvasId
    );

    setPDFSourceUrl(cropPDFUrl);
  };

  useEffect(() => {
    setCropPDFSourceUrl();
  }, []);

  return pdfSourceUrl ? (
    <Source
      coordinates={sheetSource.coordinates}
      type={sheetSource.type}
      url={pdfSourceUrl}
    >
      <Layer id={sheetLayer.id} type={sheetLayer.type} paint={paint} />
    </Source>
  ) : null;
};

export default CroppedSheet;
